import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  fetchChildEditionCreateFormAccess() {
    return http.get(endpoints.get('publicChildEditionCreateForm'))
  }
}
